import { useState, useRef } from "react";
import emailjs from "@emailjs/browser";
import { toast } from "react-hot-toast";

export default function ContactForm() {
  const formRef = useRef();
  const [input, setInput] = useState({
    fname: "",
    website: "",
    email: "",
    mobile: "",
    message: "",
  });

  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInput((prev) => ({ ...prev, [name]: value }));
    setError("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const { fname, website, email, mobile, message } = input;
    if (!fname || !website || !email || !mobile || !message) {
      setError("Please fill all the fields.");
      return;
    }

    emailjs
      .sendForm(
        "service_y3ltmts",
        "template_g3i8uar",
        formRef.current,
        "qmFI8BJH6fiwNd58v"
      )
      .then(() => {
        console.log("Message sent ✅");

        toast.success("Message sent successfully!", {
          duration: 2000,
          style: {
            background: "#228B22",
            border: "1px solid #228B22",
            padding: "14px 18px",
            color: "white",
            fontWeight: "500",
            fontSize: "14px",
            borderRadius: "8px",
          },
        });

        setInput({
          fname: "",
          website: "",
          email: "",
          mobile: "",
          message: "",
        });
      })
      .catch((error) => {
        console.error("EmailJS Error:", error);

        toast.error("Failed to send message. Please try again.", {
          duration: 2000,
          style: {
            background: "#c50202",
            border: "1px solid #c50202",
            padding: "14px 18px",
            color: "white",
            fontWeight: "500",
            fontSize: "14px",
            borderRadius: "8px",
          },
        });
      });
  };

  return (
    <div className="px-lg-5 space bg-theme">
      <div className="container-fluid">
        <div className="row align-items-center justify-content-between">
          <div className="col-lg-5">
            <div>
              <img src="./images/about/contact.webp" alt="" />
            </div>
          </div>
          <div className="col-lg-5">
            <div className="contact-form-wrap">
              <div className="title-area mb-30">
                <h2 className="sec-title">Have Any Project on Your Mind?</h2>
                <p>
                  Great! We're excited to hear from you and let's start
                  something
                </p>
              </div>
              <form
                ref={formRef}
                onSubmit={handleSubmit}
                className="contact-form ajax-contact"
              >
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control style-border"
                        name="fname"
                        placeholder="Full Name"
                        value={input.fname}
                        onChange={handleChange}
                        id="name"
                      />
                      {error && <p style={{ color: "red" }}>{error}</p>}
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control style-border"
                        name="website"
                        id="website"
                        placeholder="Website / Company"
                        value={input.website}
                        onChange={handleChange}
                      />
                      {error && <p style={{ color: "red" }}>{error}</p>}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        className="form-control style-border"
                        name="email"
                        id="email"
                        placeholder="Email address*"
                        value={input.email}
                        onChange={handleChange}
                      />
                      {error && <p style={{ color: "red" }}>{error}</p>}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control style-border"
                        name="mobile"
                        id="mobile"
                        placeholder="Phone Number *"
                        value={input.mobile}
                        onChange={handleChange}
                      />
                      {error && <p style={{ color: "red" }}>{error}</p>}
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="form-group">
                      <textarea
                        name="message"
                        className="form-control style-border"
                        placeholder="How Can We Help You*"
                        id="contactForm"
                        value={input.message}
                        onChange={handleChange}
                      />
                      {error && <p style={{ color: "red" }}>{error}</p>}
                    </div>
                  </div>
                </div>
                <div className="form-btn col-12">
                  <button type="submit" className="btn mt-20">
                    <span className="link-effect">
                      <span className="effect-1">SEND MESSAGE</span>
                      <span className="effect-1">SEND MESSAGE</span>
                    </span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
